<template>
  <a-entity>
    <Terrain />
    <a-entity
      ref="env"
      position="0 -.7 0"
      @loaded="envLoaded"
      environment="preset: egypt; fog: .8; dressing: none; skyColor: white; horizonColor: grey; ground: hills; groundTexture: none; groundColor: grey"
    />
    <!--Lines /-->
    <Clouds />
  </a-entity>
</template>

<script>
import Color from 'color'
import Lines from '@/components/lines/Lines'
import Clouds from '@/components/clouds/Clouds'
import Terrain from '@/components/terrain/Terrain'

export default {
  name: 'Environment',
  components: { Lines, Clouds, Terrain },
  data: () => ({
    color: '#fff',
    type: 'light',
    bk: {
      hemisphere: 0,
      directional: 0,
      fog: { r: 0, g: 0, b: 0 }
    },
    dark: {
      hemisphere: .05,
      directional: .05,
      fog: { r: 0, g: 0, b: 0 },
      bottomColor: { x: 0, y: 0, z: 0 }
    }
  }),
  watch: {
    '$route': 'setColor',
  },
  methods: {
    yoyoColorSky() {
      const time = 5
      const color = new THREE.Color(this.color)
      const newColor = new THREE.Color(this.type == 'light'
      ? Color(this.color).whiten(0.6).rgbNumber()
      : Color(this.color).darken(0.6).rgbNumber())

      TweenLite.to(this.$uniforms.topColor.value, time, {
        x: color.r,
        y: color.g,
        z: color.b,
        ease: Linear.easeInOut,
        onComplete: () => {
          TweenMax.to(this.$uniforms.topColor.value, time, {
            x: newColor.r,
            y: newColor.g,
            z: newColor.b,
            yoyo: true,
            repeat: -1,
            ease: Linear.easeInOut
          })
        }
      })
    },
    envLoaded() {
      setTimeout(() => {
        const sky = this.$el.querySelector('a-sky')
        const lights = this.$el.querySelectorAll('[light]')

        sky.object3DMap.mesh.material.side = THREE.BackSide

        this.$fog = document.querySelector('a-scene').object3D.fog
        this.$uniforms = sky.object3DMap.mesh.material.uniforms
        this.$hemisphere = _.find(lights, l => l.object3DMap.light.type == 'HemisphereLight').object3DMap.light
        this.$directional = _.find(lights, l => l.object3DMap.light.type == 'DirectionalLight').object3DMap.light

        TweenLite.to(this.$directional.position, 1, { x: -1.4, y:4.359, z:5.2 })

        this.bk.hemisphere = this.$hemisphere.intensity - .2
        this.bk.directional = this.$directional.intensity - .2
        this.bk.fog = { ...this.$fog.color }
        this.bk.bottomColor = { ...this.$uniforms.bottomColor.value }

        this.setColor()
      }, 1000)
    },
    setDarker() {
      const time = 5
      TweenLite.to(this.$hemisphere, time, { intensity: .04 })
      TweenLite.to(this.$directional, time, { intensity: .04 })
      TweenLite.to(this.$fog.color, time, { r: 0, g: 0, b: 0 })
      TweenLite.to(this.$uniforms.bottomColor.value, time, { x: 0, y: 0, z: 0 })
    },
    setLighter() {
      const time = 5
      TweenLite.to(this.$hemisphere, time, { intensity: this.bk.hemisphere })
      TweenLite.to(this.$directional, time, { intensity: this.bk.directional })
      TweenLite.to(this.$fog.color, time, { ...this.bk.fog })
      TweenLite.to(this.$uniforms.bottomColor.value, time, { ...this.bk.bottomColor })
    },
    setColor() {
      const routeName = this.$route.meta.name
      this.color = routeName == 'captation' || routeName == 'level' ? this.levels[this.$route.params.level] : '#fff'
      this.type = this.$route.params.captation || routeName == 'wait' ? 'dark' : 'light'

      if(this.type == 'light') this.setLighter()
      if(this.type == 'dark') this.setDarker()

      this.yoyoColorSky()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/environment/Environment.vue